module.exports = __webpack_public_path__ + "img/bg.04897bf9.png";